import { ElementProps } from '@/components/sections/builder/types';
import { WrapperChild } from '@/components/sections/builder/wrapper';
import { ElementDataType } from '@/components/sections/builder/elements/body/multicolumn/type';
import { cn } from '@/lib/utils';

export default function ElementContent({ element, preview }: ElementProps) {
  const content = element.data as ElementDataType;

  const childs = element.childs;

  return (
    <>
      <section
        className={cn(
          'textwithicon_wrapper',
          content.background?.type === 'color' && 'background-color',
          content.background?.type === 'image' && 'background-image'
        )}
      >
        <div className='theme_layout_page_width relative mx-auto px-3 py-4 duration-100 lg:px-4 lg:py-4'>
          <div
            className={cn(
              'mb-4 flex flex-col',
              content.titleAlign === 'left' && '[&>*]:text-left',
              content.titleAlign === 'center' && '[&>*]:text-center',
              content.titleAlign === 'right' && '[&>*]:text-right'
            )}
          >
            <h2
              className={cn(
                'theme_font_heading font-bold tracking-tight',
                content.headingSize === 'large' && 'text-xl sm:text-2xl md:text-3xl lg:text-4xl',
                content.headingSize === 'medium' && 'text-lg sm:text-xl md:text-2xl lg:text-3xl',
                content.headingSize === 'small' && 'text-2xl md:text-xl lg:text-2xl'
              )}
              data-animation='true'
              dangerouslySetInnerHTML={{ __html: content.heading }}
            />
          </div>
          <div
            className={cn(
              'flex flex-col',
              content.contentAlign === 'left' && '[&>*]:text-left',
              content.contentAlign === 'center' && '[&>*]:text-center',
              content.contentAlign === 'right' && '[&>*]:text-right'
            )}
          >
            <div className='desktop-grid-col grid grid-cols-1 gap-4 gap-y-2 md:grid-cols-2 md:gap-y-4 lg:gap-y-6'>
              {childs?.map((child) => (
                <WrapperChild
                  child={{
                    ...child,
                    parentData: {
                      ...content,
                    },
                  }}
                  parentType={element.type}
                  key={child.id}
                  preview={preview}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      <style jsx>
        {`
          @media (min-width: 1024px) {
            .desktop-grid-col {
              grid-template-columns: repeat(${content.numberOfColumns || 1}, minmax(0, 1fr));
            }
          }
          .textwithicon_wrapper {
            color: ${content.colorScheme?.text || '#52535B'} !important;
          }

          @media (min-width: 768px) {
            .textwithicon_wrapper {
              background-color: ${content.colorScheme?.background || 'white'};
              padding-top: ${content.padding?.top}px;
              padding-bottom: ${content.padding?.bottom}px;
              padding-left: ${content.padding?.left}px;
              padding-right: ${content.padding?.right}px;
            }
          }
          .textwithicon_heading {
            font-size: ${content.headingSize}px;
            line-height: ${content.headingSize}px;
            color: ${content.colorScheme?.text || '#52535B'} !important;
          }
          .text_heading {
            color: ${content.colorScheme?.text || '#111827'};
          }
          .background-color {
            background-color: ${content.background?.backgroundColor};
            --tw-bg-opacity: ${content.background?.backgroundOpacity};
          }
          .background-image {
            background-image: url(${content.background?.backgroundImage});
            background-repeat: no-repeat;
            background-size: ${content.background?.backgroundSize};
            background-position: ${content.background?.backgroundPosition};
            background-attachment: ${content.background?.backgroundAttachment};
          }
        `}
      </style>
    </>
  );
}
